/* eslint-disable react/jsx-pascal-case */
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Button from "../components/BSL_Button";
import BSL_TextInput from "../components/BSL_TextInput";
import { fetchTimeout, mergeDeep, deepCopy } from "../components/Common";
import { API_BASE } from "../AppConfig";
import { updateAPP, updateUser, loadUser } from "../redux_store/appState";
import { NEW_JOB } from "../redux_store/jobState";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import { updateBOMOrderData } from "../redux_store/jobState";
import { CircularProgress } from "@material-ui/core";
import { LYSAGHT_POAs, CENTENARY_POAs } from "./Helpers/OfferingsHelper";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { JsonView, darkStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import {
    GetTestConfig,
    getFieldersJobList,
    getFieldersJobOldBom,
    getFieldersOldJobLoad,
    getJob,
    getJobBom,
    getJobEngineering,
    getLysaghtJobList,
    getLysaghtJobOldBom,
    getLysaghtOldJobLoad,
} from "./TestScriptAdmin";
import { getBomTest, getLoadTest, syncBomTest, syncLoadTest } from "./SyncTests";
import { updateConfigAll } from "../redux_store/configState";
import { SectionRow } from "../components/BSL_CommonControls";

const jsondiffpatch = require("jsondiffpatch");

const useStyles = makeStyles({
    root: {
        width: "98%",
        display: "flex",
        flexDirection: "column",
        height: "90%",
        overflow: "scroll",
        fontSize: "small",
    },
});

function arraysAreEqual(arr1, arr2) {
    const filteredArr1 = arr1.filter((item) => item?.Add !== null && item?.Code !== "MSJ");
    const filteredArr2 = arr2.filter((item) => item?.Add !== null && item?.Code !== "MSJ");

    if (filteredArr1.length !== filteredArr2.length) {
        return false; // Different non-null item counts, not equal
    }

    for (const item1 of filteredArr1) {
        // Find a matching item in filteredArr2
        const matchingItem = filteredArr2.find(
            (item2) =>
                item1?.Code === item2?.Code &&
                item1?.Qty === item2?.Qty &&
                item1?.CodeBase === item2?.CodeBase &&
                item1?.DescAppend === item2?.DescAppend
        );

        // If no matching item was found, continue
        if (!matchingItem) {
            return false; // Items are not equal
        }
    }

    return true; // All non-null items are equal
}

export async function canLoadJobs({ app, user }) {
    // Use Promise.all to start all jobs concurrently
    let loadBoms = await getBomTest();
    let loadLoads = await getLoadTest();
    let jobs;

    if (loadBoms && loadLoads) {
        jobs = Object.keys(loadBoms);
    } else {
        jobs = window.brand === "Lysaght" ? getLysaghtJobList() : getFieldersJobList();
    }

    let testConfig = GetTestConfig({ brand: window.brand });
    const results = await Promise.all(
        jobs.map(async (job) => {
            const expectedBOM = loadBoms
                ? loadBoms[job]
                : window.brand === "Lysaght"
                ? getLysaghtJobOldBom({ jobId: job })
                : getFieldersJobOldBom({ jobId: job });

            const loadedJob = await getJob({ jobId: job, app, testConfig, user_data: user });
            const loadedJobBom = await getJobBom({
                job_data: loadedJob,
                jobId: job,
                testConfig,
                app,
            });

            return loadedJobBom != null;
        })
    );

    // Check if every result is true
    const allLoaded = results.every((result) => result === true);

    return allLoaded;
}

export async function bomPassTest({ app, user }) {
    // Use Promise.all to start all jobs concurrently
    let loadBoms = await getBomTest();
    let loadLoads = await getLoadTest();
    let jobs;

    if (loadBoms && loadLoads) {
        jobs = Object.keys(loadBoms);
    } else {
        jobs = window.brand === "Lysaght" ? getLysaghtJobList() : getFieldersJobList();
    }

    let testConfig = GetTestConfig({ brand: window.brand });

    const batchSize = 3;

    const processBatch = async (batch) => {
        return Promise.all(
            batch.map(async (job) => {
                const expectedBOM = loadBoms
                    ? loadBoms[job]
                    : window.brand === "Lysaght"
                    ? getLysaghtJobOldBom({ jobId: job })
                    : getFieldersJobOldBom({ jobId: job });

                const loadedJob = await getJob({ jobId: job, app, testConfig, user_data: user });
                const loadedJobBom = await getJobBom({
                    job_data: loadedJob,
                    jobId: job,
                    testConfig,
                    app,
                });

                return arraysAreEqual(expectedBOM, loadedJobBom.bom_system.system_items.items);
            })
        );
    };

    const results = [];
    for (let i = 0; i < jobs.length; i += batchSize) {
        const batch = jobs.slice(i, i + batchSize);
        const batchResults = await processBatch(batch);
        results.push(...batchResults);
    }

    // Check if every result is true
    const allEqual = results.every((result) => result === true);

    return allEqual;
}

export default function DebugTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [intialise, setIntialise] = React.useState(false);
    const [diagnosticData, setDiagnosticData] = React.useState(null);
    const [diagnosticDataProd, setDiagnosticDataProd] = React.useState(null);
    const [diagnosticDataTest, setDiagnosticDataTest] = React.useState(null);
    const [method, setMethod] = React.useState("GET");
    const [loading, setLoading] = React.useState("");
    const [progress, setProgress] = React.useState(0);
    const [flushStatus, setFlushStatus] = React.useState("");
    const [priceRise, setPriceRise] = React.useState();
    const [lyvesCode, setLyvesCode] = React.useState("");
    const [POAState, setPOAState] = React.useState("");
    const [json_data, set_json_data_to_view] = React.useState({});

    let json_data_to_view = json_data;

    if (diagnosticData) json_data_to_view["LOCAL"] = diagnosticData;
    if (diagnosticDataTest) json_data_to_view["TEST"] = diagnosticDataTest;
    if (diagnosticDataProd) json_data_to_view["PRODUCTION"] = diagnosticDataProd;

    const [APITestURL, setAPITestURL] = React.useState(API_BASE() + "IsAlive");

    const config = useSelector((state) => state.config);
    const job = useSelector((state) => state.job);
    const pricefile = useSelector((state) => state.app.pricefile);
    const user = useSelector((state) => state.app.user);
    const app = useSelector((state) => state.app);
    const [poa, setPOA] = React.useState(job?.App?.temp_POA ? job.App.temp_POA : config?.region?.id);

    const [loadingCsv, setLoadingCsv] = useState(false);
    const [archiveBusinessErrorMsg, setArchiveBusinessErrorMsg] = useState("");

    const handleFileChange = (event) => {
        setLoadingCsv(true);
        const file = event.target.files?.[0];
        if (!file) {
            setLoadingCsv(false);
            return;
        }

        if (file.type !== "text/csv") {
            alert("Please upload a valid CSV file.");
            setLoadingCsv(false);
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target?.result;
            if (typeof text === "string") {
                processCSV(text);
            }
            setLoadingCsv(false);
        };
        reader.onerror = () => {
            alert("Error reading file.");
            setLoadingCsv(false);
        };
        reader.readAsText(file);
    };

    // Helper function to escape regex special characters (except our wildcards * and #).
    function escapeRegExp(string) {
        return string.replace(/([.+?^${}()|[\]\\])/g, "\\$1");
    }

    /**
     * Converts a ProductCode with wildcards into a RegExp.
     * - Sequences of '*' are replaced with a group matching exactly that many alphanumeric characters.
     * - Sequences of '#' are replaced with a group matching exactly that many digits.
     */
    function buildRegexFromProductCode(code) {
        // First, escape special characters, but leave * and # intact.
        let escaped = escapeRegExp(code);

        // Replace sequences of '*' with a capturing group for alphanumerics.
        escaped = escaped.replace(/\*{2,}/g, (match) => {
            return `([A-Za-z0-9]{${match.length}})`;
        });

        // Replace sequences of '#' with a capturing group for digits.
        escaped = escaped.replace(/#{2,}/g, (match) => {
            return `(\\d{${match.length}})`;
        });

        return new RegExp("^" + escaped + "$");
    }

    const processCSV = (csvText) => {
        const rows = csvText.split("\n").map((row) => row.split(","));
        if (rows.length < 2) return;

        const header = rows[0].map((h) => h.trim());
        const customerProductIndex = header.indexOf("CUSTOMERPRODUCTNUMBER");
        const itemNumberIndex = header.indexOf("ITEMNUMBER");

        if (customerProductIndex === -1 || itemNumberIndex === -1) {
            alert("CSV must contain CUSTOMERPRODUCTNUMBER and ITEMNUMBER columns.");
            return;
        }

        // Extract CSV data from the file.
        const extractedData = rows.slice(1).map((row) => ({
            customerProductNumber: row[customerProductIndex]?.trim(),
            itemNumber: row[itemNumberIndex]?.trim(),
        }));

        // Process each item in the pricefile's "data" array.
        const updatedPriceFile = pricefile["data"].map((item) => {
            let matchedItems = [];

            // If the ProductCode contains wildcards, build a regex and test extractedData.
            if (item.ProductCode.includes("*") || item.ProductCode.includes("#")) {
                const pattern = buildRegexFromProductCode(item.ProductCode);

                matchedItems = extractedData
                    .filter((data) => pattern.test(data.customerProductNumber))
                    .map((data) => ({
                        lyvesCode: data.customerProductNumber,
                        dynamicsCode: data.itemNumber,
                    }));
            } else {
                // For product codes without wildcards, do an exact match.
                const match = extractedData.find((data) => data.customerProductNumber === item.ProductCode);
                if (match) {
                    matchedItems.push({
                        lyvesCode: match.customerProductNumber,
                        dynamicsCode: match.itemNumber,
                    });
                }
            }

            // Add a property "MatchedItems" containing all matches (or empty array if none found)
            return {
                ...item,
                MatchedItems: matchedItems.length > 0 ? matchedItems : [],
            };
        });

        // Build a new DMap from the updated pricefile.
        // DMap is a mapping from lyvesCode to dynamicsCode.
        const newDMap = {};
        updatedPriceFile.forEach((item) => {
            item.MatchedItems.forEach((match) => {
                newDMap[match.lyvesCode] = match.dynamicsCode;
            });
        });

        // Create a new pricefile object containing both DMap and the updated data array.
        const updatedPriceFileObject = {
            ...pricefile,
            DMap: newDMap,
            data: updatedPriceFile,
        };

        // Send updated data to API
        const api_url = API_BASE() + "admin/UpdatePriceFile?action=BulkUpdate";

        fetchTimeout(api_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedPriceFileObject),
        }).catch((error) => console.error("API request failed:", error));
    };

    let brand = window.LYSAGHT ? "Lysaght" : "Fielders";

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "IsAlive/";
            fetchTimeout(api_url, {
                method: "POST",
            })
                .then((response) => response.json())
                .then((json) => {
                    setDiagnosticData(json);
                    setIntialise(true);
                })
                .catch((e) => {});

            let api_url_test = "https://test.centenarydesignsuite.fielders.com.au/api/IsAlive/";
            fetchTimeout(api_url_test, {
                method: "POST",
            })
                .then((response) => response.json())
                .then((json) => {
                    setDiagnosticDataTest(json);
                    setIntialise(true);
                })
                .catch((e) => {});

            let api_url_prod = "https://centenarydesignsuite.fielders.com.au/api/IsAlive/";
            fetchTimeout(api_url_prod, {
                method: "POST",
            })
                .then((response) => response.json())
                .then((json) => {
                    setDiagnosticDataProd(json);
                    setIntialise(true);
                })
                .catch((e) => {});
        }
        setPriceRise(app.priceRise);
    }, [intialise]);

    const item_template = {
        Add: true,
        Category: "STEEL ROOFING",
        Code: "CD42DS",
        Desc: "C-Dek 310 0.42BMT **H**",
        Use: "",
        Colour: "Classic Cream",
        Area: "0",
        Qty: "1",
        Length: "1000",
        CodeBase: "CD42DS",
        CodeAppend: "",
        DescAppend: "",
        "CL ID": "0",
        Fielders_Code: "",
        "CL DATA": {},
        "CL HEADERS": null,
        Locked: false,
        SubTotalCost: null,
        UnitCost: null,
        Unit: "LM",
        MarkupFactor: null,
        AncillaryParts: "",
        PromptCodes: "",
        Children: [],
        "Parent Item": "",
        ExtraData: null,
        CuttingData: {},
        ProductListItem: "",
        QtyCalculated: null,
        LinkedItemsData: null,
        matched_state: "no_match",
        Image_b64: "",
    };

    const flattenJSON = (obj = {}, res = {}, extraKey = "") => {
        let key = "";
        for (key in obj) {
            if (typeof obj[key] !== "object") {
                res[extraKey + key] = obj[key];
            } else {
                flattenJSON(obj[key], res, `${extraKey}${key}.`);
            }
        }
        return res;
    };

    const exportExcel = () => {
        if (!job?.QuoteParameters?.BOM?.SystemList?.items) {
            alert("there is no current job loaded, or current job does not have any BOM items generated yet");
            return;
        }

        var XLSX = require("xlsx");
        let systemList = [];

        for (var index in job?.QuoteParameters?.BOM?.SystemList?.items) {
            systemList.push(flattenJSON(job?.QuoteParameters?.BOM?.SystemList?.items[index]));
        }

        const worksheet = XLSX.utils.json_to_sheet(systemList);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "BOM");
        XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "BOM.xlsx");
    };

    const AddAllItems = () => {
        let all_pitches = [15, 20, 25, 30];
        let order_list = [];

        for (let pricefile_item of pricefile.data) {
            if (pricefile_item.Brand === "LLD") continue;

            let all_colours = pricefile_item.Colours;

            if (all_colours) all_colours = all_colours.split(",");
            if (!all_colours) all_colours = [...config.colour_arrays?.Colorbond];
            if (typeof all_colours === "String") all_colours = [all_colours];

            if (pricefile_item.ProductCode.includes("**") && pricefile_item.ProductCode.includes("@@")) {
                for (let angle of all_pitches) {
                    if (all_colours)
                        for (let colour_str of all_colours) {
                            let colour = colour_str.trim();
                            if (config?.colour_map?.[colour]?.Code) {
                                // code,  proceed
                                let code = config?.colour_map?.[colour]?.Code;
                                let new_item = { ...item_template };
                                new_item.Code = pricefile_item.ProductIndex;
                                new_item.Fielders_Code = pricefile_item.ProductCode.replace("**", code).replace(
                                    "@@",
                                    angle
                                );
                                new_item.Qty = "1";
                                if (pricefile_item.SellingUOM == "LM") new_item.Length = "1000";
                                else new_item.Length = "";
                                new_item.Category = pricefile_item.GroupingName;
                                new_item.CodeBase = pricefile_item.ProductIndex;
                                new_item.Desc = pricefile_item.ProductDescription.replace("**", colour).replace(
                                    "@@",
                                    angle
                                );
                                order_list.push(new_item);
                            }
                        }
                }
            } else if (pricefile_item.ProductCode.includes("@@")) {
                for (let angle of all_pitches) {
                    let new_item = { ...item_template };
                    new_item.Code = pricefile_item.ProductIndex;
                    new_item.Fielders_Code = pricefile_item.ProductCode.replace("@@", angle);
                    new_item.Qty = "1";

                    if (pricefile_item.SellingUOM == "LM") new_item.Length = "1000";
                    else new_item.Length = "";

                    new_item.Category = pricefile_item.GroupingName;
                    new_item.CodeBase = pricefile_item.ProductIndex;
                    new_item.Desc = pricefile_item.ProductDescription.replace("@@", angle);
                    order_list.push(new_item);
                }
            } else if (pricefile_item.ProductCode.includes("**")) {
                if (all_colours)
                    for (let colour_str of all_colours) {
                        let colour = colour_str.trim();

                        if (config?.colour_map?.[colour]?.Code) {
                            let code = config?.colour_map?.[colour]?.Code;
                            let new_item = { ...item_template };
                            new_item.Code = pricefile_item.ProductIndex;
                            new_item.Fielders_Code = pricefile_item.ProductCode.replace("**", code);
                            new_item.Qty = "1";
                            if (pricefile_item.SellingUOM == "LM") new_item.Length = "1000";
                            else new_item.Length = "";
                            new_item.Category = pricefile_item.GroupingName;
                            new_item.CodeBase = pricefile_item.ProductIndex;
                            new_item.Desc = pricefile_item.ProductDescription.replace("**", colour);
                            order_list.push(new_item);
                        }
                    }
            } else {
                let new_item = { ...item_template };
                new_item.Code = pricefile_item.ProductIndex;
                new_item.Fielders_Code = pricefile_item.ProductCode;
                new_item.Qty = "1";

                if (pricefile_item.SellingUOM == "LM") new_item.Length = "1000";
                else new_item.Length = "";

                new_item.Category = pricefile_item.GroupingName;
                new_item.CodeBase = pricefile_item.ProductIndex;
                new_item.Desc = pricefile_item.ProductDescription;
                order_list.push(new_item);
            }
        }

        let output = "";

        for (let new_item of order_list) {
            output +=
                new_item.Code +
                "," +
                new_item.Fielders_Code +
                "," +
                new_item.Qty +
                "," +
                new_item.Length +
                "," +
                new_item.Category +
                "," +
                new_item.Desc +
                "\n";
        }

        var element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(output));
        element.setAttribute("download", job.id + "_BIGORDERLIST.JSON");

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);

        let order_list_bom = {
            items: order_list,
            total_price: 1,
            total_eprice: 1,
        };
        dispatch(updateBOMOrderData(order_list_bom));
    };

    const RestartQQServerUsingHelper = () => {
        setLoading("Restart");
        let api_url = API_BASE() + "admin/SendHelperCommand?command=RestartAll";
        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                setLoading("");
            })
            .catch((e) => {
                setLoading("");
            });
    };
    const UpdateQQServerUsingHelper = () => {
        setLoading("Update");
        let api_url = API_BASE() + "admin/SendHelperCommand?command=UpdateQQ";
        fetchTimeout(
            api_url,
            {
                method: "GET",
            },
            60000
        )
            .then((response) => response.json())
            .then((json) => {
                dispatch(loadUser(user.id, "cent2021")).then((result) => {
                    setLoading("");
                });
            })
            .catch((e) => {
                setLoading("");
            });
    };

    const GetUserList = () => {
        let api_url = API_BASE() + "admin/GetUserSummaryAsync";
        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                let new_data = { ...json_data_to_view };
                new_data["USER SUMMARY"] = json;
                set_json_data_to_view(new_data);
            })
            .catch((e) => {
                setLoading("");
            });
    };

    function findDifferentItems(arr1, arr2) {
        const differentItems = [];

        if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
            return differentItems;
        }

        for (const item1 of arr1) {
            if (!item1 || item1?.Add === null || item1?.Code === "MSJ") {
                continue;
            }

            const matchingItem = arr2.find(
                (item2) =>
                    item1?.Code === item2?.Code &&
                    item1?.Qty === item2?.Qty &&
                    item1?.CodeBase === item2?.CodeBase &&
                    item1?.DescAppend === item2?.DescAppend
            );

            if (!matchingItem) {
                differentItems.push(item1);
            }
        }

        for (const item2 of arr2) {
            if (!item2 || item2?.Add === null || item2?.Code === "MSJ") {
                continue;
            }

            const matchingItem = arr1.find(
                (item1) =>
                    item1?.Code === item2?.Code &&
                    item1?.Qty === item2?.Qty &&
                    item1?.CodeBase === item2?.CodeBase &&
                    item1?.DescAppend === item2?.DescAppend
            );

            if (!matchingItem) {
                differentItems.push(item2);
            }
        }

        return differentItems;
    }

    const GetTestScripts = async (resync) => {
        setLoading("tests");

        let loadBoms = await getBomTest();
        let loadLoads = await getLoadTest();
        let jobs;

        if (loadBoms && loadLoads) {
            jobs = Object.keys(loadBoms);
        } else {
            jobs = window.brand === "Lysaght" ? getLysaghtJobList() : getFieldersJobList();
        }

        let new_data = { ...json_data_to_view };
        const totalJobs = jobs.length;
        let completedJobs = 0;

        const testConfig = GetTestConfig({ brand: window.brand });

        let syncBom = {};
        let syncLoad = {};

        const processJobData = async (job) => {
            if (!new_data["Job Data"] || !new_data["Job Data"][job]) {
                new_data["Job Data"] = { ...new_data["Job Data"], [job]: { job: {}, bom: {}, loads: {}, tests: {} } };
            }

            const loadedJob = await getJob({ jobId: job, app, testConfig, user_data: user });
            new_data["Job Data"][job]["job"] = loadedJob;

            const loadedJobBom = await getJobBom({
                job_data: loadedJob,
                jobId: job,
                testConfig,
                app,
            });

            new_data["Job Data"][job]["bom"] = loadedJobBom;

            const loadedJobLoads = await getJobEngineering({ job_data: loadedJob, jobId: job, testConfig, app });
            new_data["Job Data"][job]["loads"] = loadedJobLoads;

            const expectedBOM = loadBoms
                ? loadBoms[job]
                : window.brand === "Lysaght"
                ? getLysaghtJobOldBom({ jobId: job })
                : getFieldersJobOldBom({ jobId: job });

            const expectedLoad = loadLoads
                ? loadLoads[job]
                : window.brand === "Lysaght"
                ? getLysaghtOldJobLoad({ jobId: job })
                : getFieldersOldJobLoad({ jobId: job });

            const compareBoms = {
                Expected: expectedBOM,
                Actual: loadedJobBom.bom_system.system_items.items,
                Equal: arraysAreEqual(expectedBOM, loadedJobBom.bom_system.system_items.items),
                differentItems: findDifferentItems(expectedBOM, loadedJobBom.bom_system.system_items.items),
            };

            if (resync) {
                syncBom[job] = loadedJobBom.bom_system.system_items.items;
                syncLoad[job] = loadedJobLoads.EngineeringResults;
            }

            new_data["Job Data"][job]["tests"]["bom"] = compareBoms;

            const compareLoads = {
                Expected: expectedLoad,
                Actual: loadedJobLoads.EngineeringResults,
            };

            new_data["Job Data"][job]["tests"]["loads"] = compareLoads;

            const bomDiff = jsondiffpatch.diff(compareBoms.Expected, compareBoms.Actual);
            const loadsDiff = jsondiffpatch.diff(compareLoads.Expected, compareLoads.Actual);

            new_data["Job Data"][job]["tests"]["bomDiff"] = bomDiff;
            new_data["Job Data"][job]["tests"]["loadsDiff"] = loadsDiff;

            const prefix = compareBoms.Equal ? "✓" : "⮾";

            const prefixedJobKey = `${prefix} ${job}`;
            new_data["Job Data"][prefixedJobKey] = new_data["Job Data"][job];

            delete new_data["Job Data"][job];

            completedJobs++;
            const currentProgress = (completedJobs / totalJobs) * 100;
            setProgress(currentProgress);
        };

        const processJobsConcurrently = async (jobs) => {
            const batchSize = 3;

            for (let i = 0; i < jobs.length; i += batchSize) {
                const batch = jobs.slice(i, i + batchSize);
                await Promise.all(batch.map((job) => processJobData(job)));
            }
        };

        await processJobsConcurrently(jobs);

        if (resync) {
            syncBomTest({ newBom: syncBom });
            syncLoadTest({ newLoad: syncLoad });
            setLoading("");
            setProgress(0);
            return;
        }

        const pass = Object.values(new_data["Job Data"]).every((obj) =>
            Object.keys(obj).every((key) => {
                return obj[key] === "✓";
            })
        );

        new_data["Job Data"]["Passed"] = pass;

        set_json_data_to_view(new_data);
        setLoading("");
        setProgress(0);
    };

    const GetPriceFile = () => {
        let api_url = API_BASE() + "/admin/GetPriceFileData";

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                const priceFileData = json.PRICE_FILE.data;

                if (!Array.isArray(priceFileData)) {
                    console.error("JSON data is not an array of objects.");
                    setLoading("");
                    return;
                }

                if (priceFileData.length === 0) {
                    console.warn("JSON data is empty.");
                    setLoading("");
                    return;
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("PriceFile");
                const headers = Object.keys(priceFileData[0]);

                worksheet.addRow(headers);
                priceFileData.forEach((row) => {
                    const rowData = headers.map((header) => row[header]);
                    worksheet.addRow(rowData);
                });

                return workbook.xlsx.writeBuffer();
            })
            .then((buffer) => {
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "Pricefile.xlsx");
            })
            .catch((e) => {
                setLoading("");
            });
    };

    const GetPricingReport = () => {
        let api_url = API_BASE() + "/admin/GetPriceFileData";

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                const priceFileData = json.PRICE_FILE.data;

                if (!Array.isArray(priceFileData)) {
                    console.error("JSON data is not an array of objects.");
                    setLoading("");
                    return;
                }

                if (priceFileData.length === 0) {
                    console.warn("JSON data is empty.");
                    setLoading("");
                    return;
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("PricingReport");

                let headers = Object.keys(priceFileData[0]).filter((header) =>
                    ["ProductIndex", "ProductCode", "ProductGroup", "SubGroup"].includes(header)
                );

                headers.push("Brand");
                headers.push("State-LLD");
                headers.push("State-CDS");

                const headerRow = worksheet.addRow(headers);

                worksheet.autoFilter = {
                    from: {
                        row: headerRow.number,
                        column: 1,
                    },
                    to: {
                        row: headerRow.number,
                        column: headers.length,
                    },
                };

                headerRow.eachCell((cell) => {
                    cell.font = { bold: true };
                });

                const emptyCellStyle = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFD3D3D3" },
                };

                priceFileData.forEach((row) => {
                    const rowData = headers.map((header) => {
                        if (header === "State-LLD") {
                            let stateData = row["State"];

                            return stateData.hasOwnProperty("LLD") ? stateData["LLD"].join(", ") : "";
                        } else if (header === "State-CDS") {
                            let stateData = row["State"];

                            return stateData.hasOwnProperty("CDS") ? stateData["CDS"].join(", ") : "";
                        } else if (header === "Brand") {
                            let stateData = row["State"];
                            let brands = [];

                            if (stateData.hasOwnProperty("LLD") && stateData["LLD"].length > 0) {
                                brands.push("LLD");
                            }
                            if (stateData.hasOwnProperty("CDS") && stateData["CDS"].length > 0) {
                                brands.push("CDS");
                            }
                            return brands.join(", ");
                        }

                        return row[header];
                    });
                    const newRow = worksheet.addRow(rowData);
                    newRow.eachCell((cell, colNumber) => {
                        if (cell.value === "") {
                            cell.fill = emptyCellStyle;
                        }
                    });
                });

                return workbook.xlsx.writeBuffer();
            })
            .then((buffer) => {
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "PricingReport.xlsx");
            })
            .catch((e) => {
                setLoading("");
            });
    };

    const GetUnpricedItems = () => {
        let api_url =
            API_BASE() +
            "/admin/GetProdAccountsNotPriced?lyves_account=" +
            lyvesCode +
            "&selected_poa=" +
            POAState.toUpperCase();

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                var element = document.createElement("a");
                element.setAttribute(
                    "href",
                    "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(json, null, 2))
                );
                element.setAttribute("download", (lyvesCode ? lyvesCode : "ALL_LLD_ACTIVE") + "_no_eprices.json");

                element.style.display = "none";
                document.body.appendChild(element);

                element.click();
                document.body.removeChild(element);
            })
            .catch((e) => {
                setLoading("");
            });
    };

    const UpdateUnpricedItems = () => {
        let api_url = API_BASE() + "/admin/GetePricing?account=" + lyvesCode;

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                window.alert(toString(json));
            })
            .catch((e) => {
                setLoading("");
            });
    };

    const FlushCaches = () => {
        setLoading("FlushCache");
        setFlushStatus("...flushing");
        let api_url = API_BASE() + "admin/FlushCaches";
        fetchTimeout(api_url, {
            method: "POST",
        })
            .then((response) => response.json())
            .then((json) => {
                setLoading("");
                setFlushStatus("...Success!");
                alert("success updating Flushing Caches");
            })
            .catch((e) => {
                setFlushStatus("...Error!");
                setLoading("");
            });
    };

    const SyncTestToDev = () => {
        setLoading("SyncDev");
        let api_url = API_BASE() + "admin/SyncTestToDev";
        fetchTimeout(api_url, {
            method: "POST",
        })
            .then((response) => response.json())
            .then((json) => {
                dispatch(loadUser(user.id, "cent2021")).then((result) => {
                    setLoading("");
                    alert("success updating DEV SERVERS");
                });
            })
            .catch((e) => {
                setLoading("");
                alert("Error flushing cache: " + e);
            });
    };

    const SyncTestToProd = () => {
        setLoading("SyncProd");
        let api_url = API_BASE() + "admin/SyncTestToProd";
        fetchTimeout(api_url, {
            method: "POST",
        })
            .then((response) => response.json())
            .then((json) => {
                dispatch(loadUser(user.id, "cent2021")).then((result) => {
                    setLoading("");
                    alert("success updating PRODUCTION SERVERS");
                });
            })
            .catch((e) => {
                setLoading("");
            });
    };

    function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
    }

    function jsonToCSV(jsonData, headers) {
        if (!headers && jsonData.length > 0) {
            headers = Object.keys(jsonData[0]);
        }

        const csvRows = [
            headers.join(","),
            ...jsonData.map((row) => headers.map((fieldName) => JSON.stringify(row[fieldName] || "")).join(",")),
        ];

        return csvRows.join("\n");
    }

    function downloadCSV(csvData, filename = "export.csv") {
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    const GetPricingTierAccounts = () => {
        setLoading("PricingAccounts");

        const lysaghtPOAs = LYSAGHT_POAs.filter((poa) => poa !== "MASTER").join(",");
        const centenaryPOAs = CENTENARY_POAs.filter((poa) => poa !== "MASTER").join(",");

        const apiUrl = `${API_BASE()}admin/GetPricingAccounts?lysaght_poa=${encodeURIComponent(
            lysaghtPOAs
        )}&centenary_poa=${encodeURIComponent(centenaryPOAs)}`;

        fetchTimeout(apiUrl, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                const csvData = jsonToCSV(json);
                const currentDate = new Date();
                const dateString = currentDate.toISOString().split("T")[0];
                const filename = `pricing_tier_accounts_${dateString}.csv`;
                setLoading("");
                downloadCSV(csvData, filename);
            })
            .catch((e) => {
                setLoading("");
                console.error("Pricing tier accounts export error", e);
            });
    };

    const ArchiveBusinessLicenses = () => {
        setLoading("ArchivingBuinesses");
        const apiUrl = `${API_BASE()}admin/ArchiveBusinesses`;

        fetchTimeout(apiUrl, {
            method: "GET",
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errorJson = await response.json().catch(() => null);
                    const errorMessage = errorJson?.message || "ArchivingBusinessError";

                    throw new Error(errorMessage);
                }
                return response.json();
            })
            .then((json) => {
                if (!json || json.length === 0) {
                    setLoading("");
                    setArchiveBusinessErrorMsg("No eligible businesses found for archiving.");
                    return;
                }

                const csvData = jsonToCSV(json);
                const currentDate = new Date();
                const dateString = currentDate.toISOString().split("T")[0];
                const filename = `archived_businesses_${dateString}.csv`;

                setLoading("");
                downloadCSV(csvData, filename);
            })
            .catch((e) => {
                setLoading("");
                setArchiveBusinessErrorMsg(e.message);
                console.error("Archiving businesses error", e);
            });
    };

    return (
        <div className={classes.root}>
            <SectionRow style={{ paddingTop: "0px" }}>
                <SegmentedButtonGroup
                    label="Method"
                    value={method}
                    items={["GET", "POST"]}
                    onChange={(e, v) => setMethod(v)}
                    style={{ flex: "none" }}
                />
                <BSL_TextInput
                    label="Test API"
                    value={APITestURL}
                    onEnter={(e) => {
                        let val = e.target.value;
                        setAPITestURL(val);

                        let api_url = val;
                        console.warn("getting", api_url);
                        fetchTimeout(
                            api_url,
                            {
                                method: method,
                            },
                            240000
                        )
                            .then(async (response) => {
                                console.warn(response.status);
                                let response_text = await response.text();
                                console.warn(response_text);
                            })
                            .catch((e) => {
                                console.warn("ERROR", e);
                            });
                    }}
                />
                <BSL_TextInput
                    label="Role Code"
                    preValidate="number"
                    min={0}
                    ma={99}
                    value={user.Role}
                    style={{ flex: "none" }}
                    onBlur={(v) => {
                        dispatch(updateAPP("user", { ...user, Role: v }));
                    }}
                />
                <SegmentedButtonGroup
                    label="TEST POA"
                    value={poa}
                    items={app?.offerings?.[brand]?.Regions ? Object.keys(app?.offerings?.[brand]?.Regions) : [poa]}
                    onChange={(e, val) => {
                        setPOA(val);
                        let region_offering = deepCopy(app?.offerings?.[brand]?.Regions?.[val]);
                        let master_offering = deepCopy(app?.offerings?.[brand]?.Master);
                        let new_config = mergeDeep({ ...master_offering }, { ...region_offering });
                        new_config.region.id = val;
                        dispatch(updateConfigAll(new_config));

                        if (job) {
                            let new_job = deepCopy(job);
                            new_job.Distributor.POA = val;
                            new_job.App.temp_POA = val;
                            if (new_job?.QuoteParameters?.BOM?.QuoteData?.CURRENT_DEALER?.POA)
                                new_job.QuoteParameters.BOM.QuoteData.CURRENT_DEALER.POA = val;
                            dispatch({
                                type: NEW_JOB,
                                parameter: deepCopy(new_job),
                            });
                        }
                    }}
                    style={{
                        flex: "inherit",
                    }}
                />
            </SectionRow>
            <BSL_Button onClick={AddAllItems}>Generate Order List On Current Job with All Items</BSL_Button>
            <BSL_Button onClick={() => exportExcel()}>Export Current Job to Excel</BSL_Button>
            <BSL_Button disabled={loading === "Restart"} onClick={RestartQQServerUsingHelper}>
                Restart QQ Server
                {loading === "Restart" && <CircularProgress />}
            </BSL_Button>
            <BSL_Button disabled={loading === "Update"} onClick={UpdateQQServerUsingHelper}>
                Update QQ Server and Local Databases
                {loading === "Update" && <CircularProgress />}
            </BSL_Button>
            {window.test && (
                <BSL_Button
                    disabled={loading === "SyncProd"}
                    onClick={SyncTestToProd}
                    style={{ marginTop: "20px", background: "green" }}
                >
                    PUBLISH Test Server ={">"} PROD Server (copies TEST materials, offering and pricefile to PRODUCTION)
                    {loading === "SyncProd" && <CircularProgress />}
                </BSL_Button>
            )}
            {window.debug && (
                <BSL_Button disabled={loading === "SyncDev"} onClick={SyncTestToDev} style={{ marginTop: "20px" }}>
                    Sync Test Server ={">"} Dev Server (copies TEST materials, offering and pricefile to dev)
                    {loading === "SyncDev" && <CircularProgress />}
                </BSL_Button>
            )}

            <BSL_Button onClick={GetUserList} style={{ marginTop: "20px" }}>
                Get User List Summary
            </BSL_Button>

            <div style={{ padding: 5 }}>
                {loadingCsv ? (
                    <label>Loading ...</label>
                ) : (
                    <>
                        <label style={{ display: "block", marginBottom: "8px" }}>Update Price File PRN Codes</label>
                        <input type="file" accept=".csv" onChange={handleFileChange} />
                    </>
                )}
            </div>

            {user.Role == 99 && (
                <SectionRow style={{ paddingTop: "0px" }}>
                    <BSL_Button onClick={GetPriceFile} style={{ marginTop: "20px" }}>
                        Get Price File
                    </BSL_Button>
                    <BSL_TextInput
                        label="Lyves Code"
                        value={lyvesCode}
                        style={{ flex: "none", marginLeft: "20px" }}
                        onBlur={(v) => {
                            setLyvesCode(v);
                        }}
                        helperText={"leaving blank will return ALL ACTIVE LLD including PAT accts"}
                    />
                    <BSL_TextInput
                        label="POA"
                        value={POAState}
                        style={{ flex: "none", marginLeft: "20px" }}
                        onBlur={(v) => {
                            setPOAState(v);
                        }}
                        helperText={"leaving blank will return ALL unpriced items"}
                    />
                    <BSL_Button onClick={GetUnpricedItems} style={{ marginTop: "20px" }}>
                        Get Unpriced ePrice Items for LYVES Code / POA
                    </BSL_Button>
                    <BSL_Button onClick={UpdateUnpricedItems} style={{ marginTop: "20px" }}>
                        Update ePrice (XML) Items from LYVES Code
                    </BSL_Button>
                </SectionRow>
            )}
            {user.Role === 99 && (
                <SectionRow>
                    <BSL_TextInput
                        label="EFFECTIVE START DATE"
                        value={priceRise?.price_rise_start_date}
                        style={{ flex: "none", marginLeft: "20px" }}
                        onBlur={(v) => {
                            setPriceRise({ ...priceRise, price_rise_start_date: v });
                        }}
                    />
                    <BSL_TextInput
                        label="PRICE RISE ACTIVE"
                        value={priceRise?.price_rise_active}
                        style={{ flex: "none", marginLeft: "20px" }}
                        onBlur={(v) => {
                            setPriceRise({ ...priceRise, price_rise_active: v });
                        }}
                    />
                    <BSL_Button
                        label="Submit Change"
                        value=""
                        style={{ flex: "none", marginLeft: "20px" }}
                        onClick={async (v) => {
                            const api_url = API_BASE() + "admin/UpdatePriceRiseAsync";

                            await fetchTimeout(api_url, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(priceRise),
                            }).catch((error) => console.error("API request failed:", error));
                        }}
                    />
                </SectionRow>
            )}
            {user.Role == 99 && (
                <SectionRow style={{ paddingTop: "0px" }}>
                    <BSL_Button onClick={GetPricingReport} style={{ marginTop: "20px" }}>
                        Get ePricing Report
                    </BSL_Button>
                </SectionRow>
            )}
            {user.Role == 99 && loading ? (
                <div>
                    <p>Loading...</p>
                    <progress value={progress} max={100}></progress>
                </div>
            ) : (
                <>
                    <BSL_Button onClick={() => GetTestScripts(false)} style={{ marginTop: "20px" }}>
                        Run Test Scripts
                    </BSL_Button>
                    <BSL_Button onClick={() => GetTestScripts(true)} style={{ marginTop: "20px" }}>
                        Sync Test Scripts
                    </BSL_Button>
                </>
            )}
            {user.Role == 99 && (
                <BSL_Button disabled={loading === "FlushCache"} onClick={FlushCaches} style={{ marginTop: "20px" }}>
                    Flush Memory Caches {flushStatus}
                    {loading === "FlushCache" && <CircularProgress />}
                </BSL_Button>
            )}
            {user.Role == 99 && (
                <SectionRow style={{ paddingTop: "0px" }}>
                    <BSL_Button onClick={GetPricingTierAccounts} style={{ marginTop: "20px" }}>
                        Export Pricing Tier Accounts
                        {loading === "PricingAccounts" && <CircularProgress />}
                    </BSL_Button>
                </SectionRow>
            )}

            {user.Role == 99 && (
                <SectionRow style={{ paddingTop: "0px", display: "flex", alignItems: "center" }}>
                    <BSL_Button onClick={ArchiveBusinessLicenses} style={{ marginTop: "20px", marginRight: "16px" }}>
                        Archive Business Licenses With No Active Users
                        {loading === "ArchivingBuinesses" && <CircularProgress />}
                    </BSL_Button>
                    {archiveBusinessErrorMsg && (
                        <span
                            style={{
                                color: "red",
                                fontSize: "12px",
                                marginLeft: 8,
                                marginTop: "12px",
                                whiteSpace: "pre-line",
                            }}
                        >
                            {archiveBusinessErrorMsg}
                        </span>
                    )}
                </SectionRow>
            )}

            <JsonView
                data={json_data_to_view}
                shouldInitiallyExpand={(level) => {
                    if (level <= 0) return true;
                    else return false;
                }}
                style={darkStyles}
            />
        </div>
    );
}
